import { render, staticRenderFns } from "./SpcmStudentScholarshipReco.vue?vue&type=template&id=6ea7d83d&lang=true"
import script from "./SpcmStudentScholarshipReco.vue?vue&type=script&lang=js"
export * from "./SpcmStudentScholarshipReco.vue?vue&type=script&lang=js"
import style0 from "./SpcmStudentScholarshipReco.vue?vue&type=style&index=0&id=6ea7d83d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports